import { render, staticRenderFns } from "./TableRequestProductoComponent.vue?vue&type=template&id=36c67948&scoped=true"
import script from "./TableRequestProductoComponent.vue?vue&type=script&lang=js"
export * from "./TableRequestProductoComponent.vue?vue&type=script&lang=js"
import style0 from "./TableRequestProductoComponent.vue?vue&type=style&index=0&id=36c67948&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c67948",
  null
  
)

export default component.exports